module.exports = __webpack_public_path__ + "6d5ed09545ddcb9a3fc13959a3f6b7be.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/luxenta/Luxenta-SemiBold.woff2
// module id = 1575
// module chunks = 0